export const returnExchangeDownloadFormVariables = [
    { label: '반품/교환 ID', fieldName: '_id' },
    { label: '반품/교환 UUID', fieldName: 'uuid' },
    { label: '회수수량', fieldName: 'returnExchangeQuantity' },
    { label: '반품/교환 타입', fieldName: 'returnExchangeType' },
    { label: '반품/교환 진행상태', fieldName: 'returnExchangeProceedStatus' },
    { label: '배송비지불방법', fieldName: 'returnExchangeDeliveryPaidMethod' },
    { label: '고객요청수거방법', fieldName: 'customerRequestCollectionMethod' },
    { label: '회수운송장번호', fieldName: 'collectionWaybillNumber' },
    { label: '클레임시스템', fieldName: 'claimSystem' },
    { label: '클레임고객', fieldName: 'claimCustomer' },
    { label: '반품/교환 배송비', fieldName: 'returnExchangeDeliveryCharge' },
    { label: '반품/교환 추가비용', fieldName: 'returnExchangeExtraCharge' },
    { label: '반품/교환 메모1', fieldName: 'returnExchangeMemo1' },
    { label: '반품/교환 메모2', fieldName: 'returnExchangeMemo2' },
    { label: '교환재배송 [M]상품명', fieldName: 'exchangeReShipmentOrder$productName' },
    { label: '교환재배송 [M]상품태그', fieldName: 'exchangeReShipmentOrder$productTag' },
    { label: '교환재배송 [M]옵션명', fieldName: 'exchangeReShipmentOrder$productOptionName' },
    { label: '교환재배송 [M]옵션태그', fieldName: 'exchangeReShipmentOrder$productOptionTag' },
    { label: '교환출고수량', fieldName: 'exchangeReleaseQuantity' },
    { label: '교환출고옵션코드', fieldName: 'exchangeReleaseOptionCode' },
    { label: '교환재배송일시', fieldName: 'exchangeReShipmentAt' },
    { label: '교환재배송운송장번호', fieldName: 'exchangeReShipmentWaybillNumber' },
    { label: '교환재배송지', fieldName: 'exchangeReShipmentDestination' },
    { label: '교환재배송지상세', fieldName: 'exchangeReShipmentDestinationDetail' },
    { label: '교환재배송우편번호', fieldName: 'exchangeReShipmentZipCode' },
    { label: '교환재배송수취인', fieldName: 'exchangeReShipmentReceiver' },
    { label: '교환재배송수취인연락처1', fieldName: 'exchangeReShipmentReceiverContact1' },
    { label: '교환재배송수취인연락처2', fieldName: 'exchangeReShipmentReceiverContact2' },
    { label: '교환재배송배송비', fieldName: 'exchangeReShipmentDeliveryCharge' },
    { label: '보관함 ID', fieldName: 'returnExchangeArchiveId' },
    { label: '생성일시', fieldName: 'createdAt' },
    { label: 'ERP 아이템 ID', fieldName: 'erpItemId' },
    { label: 'ERP 주문정보 ID', fieldName: 'erpItemOrderInfoId' },
    { label: 'ERP 수취인정보 ID', fieldName: 'erpItemReceiverInfoId' },
    { label: 'ERP 배송정보 ID', fieldName: 'erpItemDeliveryInfoId' },
    { label: 'ERP 관리메모 ID', fieldName: 'erpItemManagementMemoId' },
    { label: '원주문 고유코드', fieldName: 'uniqueCode' },
    { label: '원주문 상품코드', fieldName: 'prodCode' },
    { label: '원주문 옵션코드', fieldName: 'optionCode' },
    { label: '원주문 출고옵션코드', fieldName: 'releaseOptionCode' },
    { label: '원주문 생성일시', fieldName: 'erpItemCreatedAt' },
    { label: '원주문 판매여부', fieldName: 'salesYn' },
    { label: '원주문 판매일시', fieldName: 'salesAt' },
    { label: '원주문 출고여부', fieldName: 'releaseYn' },
    { label: '원주문 출고일시', fieldName: 'releaseAt' },
    { label: '원주문 보류여부', fieldName: 'holdYn' },
    { label: '원주문 보류일시', fieldName: 'holdAt' },
    { label: '원주문 재고반영여부', fieldName: 'stockReflectYn' },
    { label: '원주문 반품여부', fieldName: 'returnYn' },
    { label: '원주문 채널주문일시', fieldName: 'channelOrderDate' },
    { label: '원주문 상품명', fieldName: 'prodName' },
    { label: '원주문 옵션명', fieldName: 'optionName' },
    { label: '원주문 수량', fieldName: 'unit' },
    { label: '원주문 판매채널', fieldName: 'salesChannel' },
    { label: '원주문 주문번호1', fieldName: 'orderNumber1' },
    { label: '원주문 주문번호2', fieldName: 'orderNumber2' },
    { label: '원주문 채널상품코드', fieldName: 'channelProdCode' },
    { label: '원주문 채널옵션코드', fieldName: 'channelOptionCode' },
    { label: '원주문 가격', fieldName: 'price' },
    { label: '원주문 배송비', fieldName: 'deliveryCharge' },
    { label: '원주문 바코드', fieldName: 'barcode' },
    { label: '원주문 수취인', fieldName: 'receiver' },
    { label: '원주문 수취인연락처1', fieldName: 'receiverContact1' },
    { label: '원주문 수취인연락처2', fieldName: 'receiverContact2' },
    { label: '원주문 배송지', fieldName: 'destination' },
    { label: '원주문 배송지상세', fieldName: 'destinationDetail' },
    { label: '원주문 우편번호', fieldName: 'zipCode' },
    { label: '원주문 택배사', fieldName: 'courier' },
    { label: '원주문 운송유형', fieldName: 'transportType' },
    { label: '원주문 배송메시지', fieldName: 'deliveryMessage' },
    { label: '원주문 운송장번호', fieldName: 'waybillNumber' },
    { label: '운송코드', fieldName: 'freightCode' },
    { label: '원주문 출고지', fieldName: 'releaseLocation' },
    { label: '원주문 관리메모1', fieldName: 'managementMemo1' },
    { label: '원주문 관리메모2', fieldName: 'managementMemo2' },
    { label: '원주문 관리메모3', fieldName: 'managementMemo3' },
    { label: '원주문 관리메모4', fieldName: 'managementMemo4' },
    { label: '원주문 관리메모5', fieldName: 'managementMemo5' },
    { label: '원주문 관리메모6', fieldName: 'managementMemo6' },
    { label: '원주문 관리메모7', fieldName: 'managementMemo7' },
    { label: '원주문 관리메모8', fieldName: 'managementMemo8' },
    { label: '원주문 관리메모9', fieldName: 'managementMemo9' },
    { label: '원주문 관리메모10', fieldName: 'managementMemo10' },
    { label: '원주문 [M]상품명', fieldName: 'originOrder$productName' },
    { label: '원주문 [M]상품태그', fieldName: 'originOrder$productTag' },
    { label: '원주문 [M]옵션명', fieldName: 'originOrder$productOptionName' },
    { label: '원주문 [M]옵션태그', fieldName: 'originOrder$productOptionTag' },
];

// id
// uuid
// returnExchangeQuantity
// returnExchangeType
// returnExchangeProceedStatus
// returnExchangeDeliveryPaidMethod
// customerRequestCollectionMethod
// collectionWaybillNumber
// exchangeReleaseOptionCode
// exchangeReleaseQuantity
// claimSystem
// claimCustomer
// returnExchangeDeliveryCharge
// returnExchangeExtraCharge
// returnExchangeMemo1
// returnExchangeMemo2
// exchangeReShipmentAt
// exchangeReShipmentWaybillNumber
// exchangeReShipmentDestination
// exchangeReShipmentDestinationDetail
// exchangeReShipmentReceiver
// exchangeReShipmentReceiverContact1
// exchangeReShipmentReceiverContact2
// exchangeReShipmentDeliveryCharge
// returnExchangeArchiveId
// createdAt
// deletedFlag
// deletedAt
// workspaceId
// erpItemId
// erpItemOrderInfoId
// erpItemReceiverInfoId
// erpItemDeliveryInfoId
// erpItemManagementMemoId
// uniqueCode
// prodCode
// optionCode
// releaseOptionCode
// erpItemCreatedAt
// salesYn
// salesAt
// releaseYn
// releaseAt
// holdYn
// holdAt
// stockReflectYn
// returnYn
// channelOrderDate
// createdByMemberId
// prodName
// optionName
// unit
// salesChannel
// orderNumber1
// orderNumber2
// channelProdCode
// channelOptionCode
// price
// deliveryCharge
// barcode
// receiver
// receiverContact1
// receiverContact2
// destination
// destinationDetail
// zipCode
// courier
// transportType
// deliveryMessage
// waybillNumber
// freightCode
// releaseLocation
// managementMemo1
// managementMemo2
// managementMemo3
// managementMemo4
// managementMemo5
// managementMemo6
// managementMemo7
// managementMemo8
// managementMemo9
// managementMemo10